import { VOICE_AGENT_API } from "../../api/voiceAgent";
import log2 from "../../utils/log2";

const log = log2("[voiceAgent.store]");

const voiceAgent = {
    namespaced: true,
    state: {
        voices: [],
        selectedVoice: null,
    },
    getters: {
        voices: (state) => state.voices,
        selectedVoice: (state) => state.selectedVoice,
    },
    mutations: {
        SET_VOICES: (state, voices) => {
            state.voices = voices;
        },
        SET_SELECTED_VOICE: (state, voice) => {
            state.selectedVoice = voice;
        },
    },
    actions: {
        // Tüm sesleri listele
        async listVoices({ commit }) {
            try {
                log("listVoices çağrısı yapılıyor");
                const voices = await VOICE_AGENT_API.voices.list();
                commit("SET_VOICES", voices);
                return voices;
            } catch (error) {
                log("listVoices hatası:", error);
                throw error;
            }
        },
        
        // Belirli bir sesi getir
        async getVoice({ commit, state }, voiceId) {
            try {
                // Önce cache'de kontrol et
                const cachedVoice = state.voices.find(v => v.voice_id === voiceId);
                if (cachedVoice) {
                    return cachedVoice;
                }
                
                // Cache'de yoksa API'den al
                log("getVoice çağrısı yapılıyor:", voiceId);
                const voice = await VOICE_AGENT_API.voices.get(voiceId);
                return voice;
            } catch (error) {
                log("getVoice hatası:", error);
                throw error;
            }
        },
        
        // Agent'ın sesini güncelle
        async updateAgentVoice({ commit }, { agentId, voiceData }) {
            try {
                log("updateAgentVoice çağrısı yapılıyor:", { agentId, voiceData });
                const result = await VOICE_AGENT_API.agents.update(agentId, voiceData);
                return result;
            } catch (error) {
                log("updateAgentVoice hatası:", error);
                throw error;
            }
        },
        
        // Özel ses klonlama
        async cloneVoice({ commit, dispatch }, formData) {
            try {
                log("cloneVoice çağrısı yapılıyor");
                const result = await VOICE_AGENT_API.voices.clone(formData);
                // Ses listesini yenile
                dispatch("listVoices");
                return result;
            } catch (error) {
                log("cloneVoice hatası:", error);
                throw error;
            }
        },
        
        // Topluluk seslerini arama
        async searchCommunityVoices({ commit }, searchQuery) {
            try {
                log("searchCommunityVoices çağrısı yapılıyor:", searchQuery);
                const result = await VOICE_AGENT_API.voices.searchCommunity(searchQuery);
                return result;
            } catch (error) {
                log("searchCommunityVoices hatası:", error);
                throw error;
            }
        },
        
        // Topluluk sesi ekleme
        async addCommunityVoice({ commit, dispatch }, { providerVoiceId, publicUserId, voiceName }) {
            try {
                log("addCommunityVoice çağrısı yapılıyor:", { providerVoiceId, publicUserId, voiceName });
                const result = await VOICE_AGENT_API.voices.addCommunity(providerVoiceId, publicUserId, voiceName);
                // Ses listesini yenile
                dispatch("listVoices");
                return result;
            } catch (error) {
                log("addCommunityVoice hatası:", error);
                throw error;
            }
        }
    }
};

export default voiceAgent; 